import React, { useEffect } from "react";

import { useState } from "react";
import { getAppBanners, getClosePortalBanners, getDisplayEverywhereBanners, getEverywhereAppBanners, getEverywhereClosePortalBanners, getEverywhereFlexicoBanners, getEverywhereFriscoBanners, getEverywhereLogicoBanners, getFlexicoBanners, getFriscoBanners, getLogicoBanners, getUrlPrefixBanners } from "./BannerUtils";
import { AdminBanner, BannerContainerProps, BannerDisplayLocation } from "./BannerTypes";
import Banner from "./Banner";
import { useLocation } from "react-router-dom";
import { ALTERNATIVE_APP_URLS } from "src/constants/AppConstants";

export default (props: BannerContainerProps) => {
    const [banners, setBanners] = useState<AdminBanner[]>([])
    const [dismissedBanners, setDismissedBanners] = useState<Set<string>>(new Set([]))
    const ln = useLocation();

    const filterDismissedBanners = (bannersToFilter: AdminBanner[]) => {
        return bannersToFilter.filter(banner => !dismissedBanners.has(banner.preferenceId))
    }

    
    const loadBanners = async () => {
        let getBannerPromises:Promise<AdminBanner[]>[] = [];
        if (props.displayLocations.includes(BannerDisplayLocation.Everywhere)) {
            getBannerPromises.push(getDisplayEverywhereBanners())
        }

        if (props.displayLocations.includes(BannerDisplayLocation.ClosePortal)) {
            getBannerPromises.push(getEverywhereClosePortalBanners())
            if (props.parameters?.closePortalOwnerId) getBannerPromises.push(getClosePortalBanners(props.parameters.closePortalOwnerId))
        }

        if (props.displayLocations.includes(BannerDisplayLocation.UrlPrefix) && props.parameters?.urlPrefix) {
            getBannerPromises.push(getUrlPrefixBanners(props.parameters.urlPrefix.toLowerCase()))
        }

        if (props.displayLocations.includes(BannerDisplayLocation.App) 
            && (
                ln.pathname.startsWith("/App/") 
                || !!ALTERNATIVE_APP_URLS.find(url => ln.pathname.startsWith(url))
            )
        ) {
            getBannerPromises.push(getEverywhereAppBanners())
            if (props.parameters?.appId) getBannerPromises.push(getAppBanners(props.parameters?.appId))
        }

        if (props.displayLocations.includes(BannerDisplayLocation.Microservice)) {
            if (props.parameters?.microserviceAction === "run") {
                getBannerPromises.push(getEverywhereFlexicoBanners())
                if (props.parameters?.microserviceId) getBannerPromises.push(getFlexicoBanners(props.parameters.microserviceId))
            } else if (props.parameters?.microserviceAction === "upload") {
                getBannerPromises.push(getEverywhereFriscoBanners())
                if (props.parameters?.microserviceId) getBannerPromises.push(getFriscoBanners(props.parameters.microserviceId))
            } else if (props.parameters?.microserviceAction === 'categorize') {
                getBannerPromises.push(getEverywhereLogicoBanners())
                if (props.parameters?.microserviceId) getBannerPromises.push(getLogicoBanners(props.parameters.microserviceId))
            }
        }

        const bannerArrays = (await Promise.all(getBannerPromises));
        const bannersToDisplay = bannerArrays.reduce((prev, bannerArray) => {
            return prev.concat(bannerArray)
        })
        setBanners(filterDismissedBanners(bannersToDisplay));
    }

    useEffect(() => {
        loadBanners();
    }, [ln.pathname, props.parameters])

    useEffect(() => {
        setBanners(filterDismissedBanners(banners))
    }, [dismissedBanners])



    return (
        <>
            {
                banners.map((banner, index) => {
                    return (
                        <Banner 
                            bannerKey={`${index}`} 
                            bannerType={banner.information.bannerType.value}
                            bannerMessage={banner.information.bannerMessage}
                            options={{
                                roundedCorners: props.roundedCorners,
                                onDismiss: banner.information.dismissible ? () => {
                                    setDismissedBanners(new Set([...Array.from(dismissedBanners), banner.preferenceId]))
                                } : undefined
                            }}
                        ></Banner>
                    )
                })
            }
        </>

    )
}